<template>
  <div class="promos">
    <CreatePromoDialog @promo-created="created" />
    <PromosTable ref="table" />
  </div>
</template>

<script>
import PromosTable from "@/components/common/PromosTable";
import CreatePromoDialog from "@/components/common/CreatePromoDialog";

export default {
  components: {
    PromosTable,
    CreatePromoDialog,
  },
  methods: {
    created() {
      this.$refs.table.getPromos({page: 1, pageSize: 10});
    },
  },
};
</script>

<style scoped lang="scss">

</style>
